module.exports = __webpack_public_path__ + "static/media/3D.b9d5e12f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3D.svg
// module id = 58
// module chunks = 0